import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ChevronSmallDown = (props: SvgIconT.Props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path d="M9.5 13a.503.503 0 0 1-.313-.109l-5-4a.5013.5013 0 0 1-.078-.703c.173-.214.488-.25.703-.078L9.5 11.86l4.688-3.75c.218-.172.531-.136.703.078.172.216.138.53-.078.703l-5 4A.501.501 0 0 1 9.5 13z"></path>
  </SvgIcon>
);

export default ChevronSmallDown;
